export default __webpack_public_path__ + "static/media/download.e6c6794a.svg";